import { programPhase } from '@/utils/programPhases';

/** Phase strip for curated programs: which block of the program the user is in. */
export const ProgramPhaseBar = ({ programName, week, durationWeeks, className = '' }) => {
  const phase = programPhase(programName, week, durationWeeks);
  if (!phase) return null;

  return (
    <div
      className={`rounded-2xl border border-white/[0.10] bg-white/[0.03] px-4 py-3 ${className}`}
      data-testid="program-phase-bar"
    >
      <div className="flex items-baseline justify-between gap-3">
        <span
          className="font-heading font-black uppercase tracking-tight text-sm text-white truncate"
          data-testid="program-phase-label"
        >
          {phase.label}
        </span>
        <span className="shrink-0 text-[11px] font-heading font-bold uppercase tracking-[0.14em] text-accent">
          Phase {phase.index}/{phase.total}
        </span>
      </div>
      <div className="mt-2 flex items-center gap-1.5" data-testid="program-phase-blocks">
        {Array.from({ length: phase.total }).map((_, i) => (
          <span
            key={i}
            className={`h-1.5 flex-1 rounded-full transition-colors ${
              i < phase.index - 1 ? 'bg-accent/45' : i === phase.index - 1 ? 'bg-accent' : 'bg-white/12'
            }`}
          />
        ))}
      </div>
      <p className="mt-2 text-xs text-white/45" data-testid="program-phase-weeks">
        Weeks {phase.from}–{phase.to} · you're in week {Math.min(week || 1, durationWeeks)} of {durationWeeks}
      </p>
    </div>
  );
};

export default ProgramPhaseBar;
